import { apiFetch } from '../apiFetch'

export const getEvents = async (params = {}) => {
  const query = new URLSearchParams(params).toString()
  return await apiFetch({
    path: `/events${query ? `?${query}` : ''}`
  })
}

export const getEvent = async (id) => {
  return await apiFetch({
    path: `/events/${id}`
  })
}

export const postEvent = async (payload) => {
  return await apiFetch({
    method: 'POST',
    path: '/events',
    payload
  })
}

export const putEvent = async (id, payload) => {
  return await apiFetch({
    method: 'PUT',
    path: `/events/${id}`,
    payload
  })
}

export const deleteEvent = async (id) => {
  return await apiFetch({
    method: 'DELETE',
    path: `/events/${id}`
  })
}
